import { waitingTimesUrl } from './resources.js'
import common from './common.js'
import store from '../store/index.js'

async function updateCurrentWaitingTimeByRestaurant(waitingtime) {
    let restaurantid = store.state.restaurants.currentRestaurant.restaurantId;
    let url = `${waitingTimesUrl}/UpdateCurrentWaitingTimeByRestaurant/${restaurantid}`;
    let data = {
        restaurantId : restaurantid,
        waitingTime : waitingtime
    };
    await common.putData(url, data)
                .catch(err => console.log(err));
 
}


export default {
    name: 'waitingTimesService',
    updateCurrentWaitingTimeByRestaurant

} 